import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/constructionAsset/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/cityDigital/img/1.avif';
import image2 from '@src/assets/images/solution/cityDigital/img/2.avif';
import image3 from '@src/assets/images/solution/cityDigital/img/3.avif';
import image4 from '@src/assets/images/solution/cityDigital/img/4.avif';
import image5 from '@src/assets/images/solution/cityDigital/img/5.avif';
import image6 from '@src/assets/images/solution/cityDigital/img/6.avif';
import image7 from '@src/assets/images/solution/cityDigital/img/7.avif';
import image8 from '@src/assets/images/solution/cityDigital/img/8.avif';

export default {
  type: '城市解决方案',

  banner: {
    title: '实时监控整个城市，构建数字化灾害应对体系',
    desc: '通过3D数字孪生实现城市空间数据的可视化，可在灾害发生前后进行预测、应对与恢复的全流程一体化管理。',
  },

  video: {
    title: '通过数字孪生实现灾害管理全流程实时联动',
    desc: '将真实城市虚拟化，并实时整合传感器、位置数据、摄像头视频等多样信息，实现灾害前的预警、发生时的应对、灾后恢复一站式系统化管理。',
    play: video,
  },

  func: [
    {
      theme: '城市灾害信息整合与实时可视化',
      title: '基于城市基础设施的综合监控',
      desc: '将道路、河流、设施、传感器等城市基础设施数据在一个平台上整合管理，实时掌握全域风险要素。',
      sub1: '实时状态把握',
      icon1: IconClockGray,
      sub2: '快速数据联动',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: '气象信息实时收集与分析',
      desc: '实时收集卫星影像、天气图、雷达数据等气象信息，提供恶劣天气预测与预警服务，量化城市气象环境，用于应急响应方案。',
      sub1: '危险资产指定',
      icon1: IconWarningGray,
      sub2: '数据云端存储',
      icon2: IconCloudCheckGray,
      image: image2,
    },
    {
      title: '实时查看各区域降雨情况',
      desc: '通过安装在城市的雨量计实时收集与分析各区域的降雨状况，发生暴雨时可优先判断需要应对的区域。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '数据云端存储',
      icon2: IconCloudCheckGray,
      image: image3,
    },
    {
      title: '河流水位及流量状态可视化',
      desc: '实时可视化主要河流的水位、流量及水闸状态，异常水位发生时可自动检测并发送风险预警。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '数据云端存储',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      theme: '灾害应对自动化及指挥中心应用',
      title: '基于综合状况的预警联动',
      desc: '综合多种数据，在指挥中心画面上一目了然地查看风险，按照不同状况自动执行定制化预警及应对触发器。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '数据云端存储',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      title: '指挥中心画面配置及实时显示',
      desc: '在灾害综合指挥中心将CCTV、警报记录、主要河流水位等信息分屏显示，进行实时监控，提升现场应对能力并快速共享整体灾害状况。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '数据云端存储',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: '灾害时远程应急体系',
      desc: '在灾害发生时，可远程执行基于TTS的村广播、短信发送、CCTV监控、远程断路器控制等紧急措施。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '数据云端存储',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: '多面板数据可视化',
      desc: '提供整合气象信息、水位、降雨量、预警指标等的多面板数据，方便在一屏内直观对比与判断，加速情况认知和决策。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '数据云端存储',
      icon2: IconCloudCheckGray,
      image: image8,
    },
  ],

  subfunc: {
    title: '多样化功能',
    desc: '医疗废物管理必须时刻保持警惕，一点疏忽或失误都可能导致重大医疗事故。因此需要极其精密且安全有保障的管理。<br/>ORBRO提供多样功能，助力构建安全高效的医疗设施。',

    data: [
      {
        icon: IconDashboard,
        title: '城市统一监控',
        desc: '道路河流等数据一体管理。',
      },
      {
        icon: IconClockGray,
        title: '气象实时收集',
        desc: '雷达卫星实时可视化。',
      },
      {
        icon: IconChartBarGray,
        title: '区域降雨分析',
        desc: '自动分析雨量区分风险区。',
      },
      {
        icon: IconChartBarGray,
        title: '河流水位监控',
        desc: '主要河流水位流量数值化警报。',
      },
      {
        icon: IconDashboard,
        title: '综合仪表盘',
        desc: 'CCTV传感器信息整合展示。',
      },
      {
        icon: IconZoneGray,
        title: '多屏显示',
        desc: '分屏显示目的画面。',
      },
      {
        icon: IconBell,
        title: '异常自动预警',
        desc: '条件满足自动警报通知。',
      },
      {
        icon: IconSecurity,
        title: 'CCTV联动控制',
        desc: '远程查看控制设备。',
      },
      {
        icon: IconRoute,
        title: '灾害场景应对',
        desc: '数据驱动应对方案自动执行。',
      },
      {
        icon: IconChartRadius,
        title: '记录自动保存',
        desc: '全部过程自动保存。',
      },
    ],
  },

  system: {
    title: '系统构成',
    img: rtlsSystem,
  },

  productTitle: '产品构成',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'medicalPatient' }, { data: 'officeAsset' }, { data: 'blogMedical' }, { data: 'blogRTLS' }],
};
